// Global assignment change event system for cross-context communication
// This enables MultiGridContext to notify TeacherLoadPanel of assignment changes

type AssignmentChangeCallback = () => void;

class AssignmentEventManager {
  private callbacks = new Set<AssignmentChangeCallback>();

  // Register a callback for assignment changes
  subscribe(callback: AssignmentChangeCallback): () => void {
    this.callbacks.add(callback);

    // Return unsubscribe function
    return () => {
      this.callbacks.delete(callback);
    };
  }

  // Notify all subscribers of assignment changes
  notify(): void {
    this.callbacks.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('Error in assignment change callback:', error);
      }
    });
  }

  // Get the number of active subscribers (for debugging)
  getSubscriberCount(): number {
    return this.callbacks.size;
  }
}

// Global instance for cross-context communication
export const assignmentEvents = new AssignmentEventManager();